import React, { Component } from 'react';
import ReactDOM from 'react-dom';

// Components
import Resizer from './resizer';

export default class ResizablePanels extends Component<any, any> {
  resizable: any
  constructor(props:any) {
    super(props);

    this.resizable = React.createRef();
    this.state = this.state;
  }
  state:any = {
    panelsSize: [],
    resizing: false
  };

  componentDidMount() {
    this.setState({ ...this.state, panelsSize: this.props.panelsSize });
    let y :any= ReactDOM;
    y?.findDOMNode(this).addEventListener(
      'mousemove',
      this.executeResize
    );
    y.findDOMNode(this).addEventListener('mouseup', this.stopResize);
    y.findDOMNode(this).addEventListener('mouseleave', this.stopResize);
  }

  render() {
    const { bkcolor } = this.props;
    let z:any = this.props.children
    const rest =
      z.length > 1 ? z.slice(1) : [];

    return (
      <div
        style={{
          width: this.props.width,
          height: this.props.height,
          background: bkcolor,
          display: 'flex',
          flexDirection: this.props.displayDirection || 'row'
        }}
        ref={this.resizable}
      >
        {this.renderFirst(z)}
        {this.renderRest(rest)}
      </div>
    );
  }

  renderFirst(z:any) {
    return this.renderChildren(z[0], 0);
  }

  renderRest(rest:any) {
    return [].concat(
      ...rest.map((children: any, index: number) => {
        return [
          this.renderResizer(index + 1),
          this.renderChildren(children, index + 1)
        ];
      })
    );
  }

  renderChildren(children: any, index: any) {
    return (
      <div
        className="resizable-fragment"
        key={`fragment_` + index}
        style={this.getStyle(index)}
      >
        {children}
      </div>
    );
  }

  renderResizer(index: string | number) {
    return (
      <Resizer
        size={this.props.resizerSize || '10px'}
        key={`resizer_` + index}
        direction={this.props.displayDirection}
        onMouseDown={(e: { preventDefault: () => void; clientY: any; clientX: any; }) => {
          this.startResize(e, index)
        }}
        color={this.props.resizerColor}
      />
    );
  }

  displayDirectionIsColumn() {
    return this.props.displayDirection === 'column' ? true : false;
  }

  getStyle(index: number|string) {
    const panelsSize = this.state.panelsSize || [];
    const panelsSizeLength = panelsSize.length - 1;
    const size = index > panelsSizeLength ? '100%' : panelsSize[index];
    const unitMeasure = this.props.sizeUnitMeasure || 'px';

    if (this.displayDirectionIsColumn()) {
      return {
        height: `${size}${unitMeasure}`,
        width: `100%`,
        overflow: 'hidden'
      };
    }

    return {
      height: `100%`,
      width: `${size}${unitMeasure}`,
      overflow: 'hidden'
    };
  }

  startResize(e: { preventDefault: () => void; clientY: any; clientX: any; }, index: string | number) {
    e.preventDefault();
    this.setState({
      ...this.state,
      resizing: true,
      currentPanel: index,
      initialPos: this.displayDirectionIsColumn() ? e.clientY : e.clientX
    });
    if (this.props.startResize) {
      this.props.startResize();
    }
  }

  executeResize = (e: { clientY: any; clientX: any; }) => {
    if (this.state.resizing) {
      const currentMousePosition = this.displayDirectionIsColumn()
        ? e.clientY
        : e.clientX;

      const displacement = this.state.initialPos - currentMousePosition;

      const nextPanelsSize = this.getNextPanelsSize(displacement);

      this.setState({
        ...this.state,
        initialPos: currentMousePosition,
        panelsSize: nextPanelsSize,
        displacement
      });
      if (this.props.onResize) {
        this.props.onResize(displacement);
      }
    }
  };

  stopResize = () => {
    this.setState({
      ...this.state,
      resizing: false,
      currentPanel: null,
      displacement: 0
    });
    if (this.props.stopResize) {
      this.props.stopResize();
    }
  };

  getCurrentComponentSize() {
    const componentSizes = this.resizable.current.getBoundingClientRect();

    return this.displayDirectionIsColumn()
      ? componentSizes.height
      : componentSizes.width;
  }

  getNextPanelsSize(displacement: number) {
    const currentPanelsSize = this.state.panelsSize;
    const usePercentage = this.props.sizeUnitMeasure === '%';

    const resizeSize = usePercentage
      ? this.convertToPercentage(displacement)
      : displacement;

    const newPanelsSize = currentPanelsSize.map((panelSize: number, index: number) => {
      if (index === this.state.currentPanel) return panelSize + resizeSize;
      else if (index === this.state.currentPanel - 1)
        return panelSize - resizeSize;

      return panelSize;
    });

    return newPanelsSize;
  }

  convertToPercentage(displacement: number) {
    const size = this.getCurrentComponentSize();

    return (displacement * 100) / size;
  }
}